import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Button, Modal, Dropdown } from "react-bootstrap";
import Axios from "axios";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftjsToHtml from "draftjs-to-html";
import htmlToDraftjs from "html-to-draftjs";
import DOMPurify from "dompurify";
import DatePicker from "react-datepicker";
import Moment from "moment";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as MoreSettingsStyles from "../styles/moreSettings";

function MoreSettings() {
  const dispatch = useDispatch();
  const [tab, setTab] = useState();
  const [invoiceMsgState, setInvoiceMsgState] = useState(
    EditorState.createEmpty()
  );
  const [receiptMsgState, setReceiptMsgState] = useState(
    EditorState.createEmpty()
  );
  const [dates, setDates] = useState({
    selected: "New",
    items: [],
  });
  const [newDate, setNewDate] = useState(new Date());
  const [updateID, setUpdateID] = useState(0);

  const [modal, setModal] = useState({
    open: false,
    header: "",
    message: "",
  });

  function handleCloseModal() {
    setModal((prevState) => {
      return { ...prevState, open: false };
    });
  }

  useEffect(() => {
    dispatch(
      GS_navSettingsActions.UpdateTitle("Online Payments - More Settings")
    );
    dispatch(GS_navSettingsActions.UpdateSelected("Features"));
    dispatch(GS_navSettingsActions.UpdateSubSelected("Online Payments"));
    handleStaementCustomMessages();
  }, []);

  function handleTabClick(tab) {
    setTab(tab);
  }

  function handleStaementCustomMessages() {
    setTab("customMessages");

    Axios.post("/pods/onlinePayments/settings/getCustomStatementMessages")
      .then((res) => {
        const data = res.data;
        if (data.error == "null") {
          setDates((prevState) => {
            return { ...prevState, items: data.statements };
          });

          handleStatementMsgs(data.statements, data.statements[0].id);
        }
      })
      .catch((err) => console.log(err));
  }

  function stringToDraftjs(text) {
    const blocksFromHTML = htmlToDraftjs(text);
    const { contentBlocks, entityMap } = blocksFromHTML;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );

    return EditorState.createWithContent(contentState);
  }

  function handleInvoiceMsgChange(editorState) {
    setInvoiceMsgState(editorState);
  }

  function handleReceiptMsgChange(editorState) {
    setReceiptMsgState(editorState);
  }

  function handleCustomMessagesSave() {
    const invoiceMsg = DOMPurify.sanitize(
      draftjsToHtml(convertToRaw(invoiceMsgState.getCurrentContent()))
    );
    const receiptMsg = DOMPurify.sanitize(
      draftjsToHtml(convertToRaw(receiptMsgState.getCurrentContent()))
    );

    const data = {
      date: Moment(newDate).format("DD/MM/YYYY"),
      invoiceMsg: invoiceMsg,
      receiptMsg: receiptMsg,
    };

    Axios.post(
      "/pods/onlinePayments/settings/saveNewCustomStatementMessages",
      data
    )
      .then((res) => {
        const data = res.data;
        if (data.error == "null") {
          setDates((prevState) => {
            return { ...prevState, items: data.statements };
          });
          handleStatementMsgs(data.statements, data.newStatementID);
          setModal({
            header: "Custom Messages",
            message: data.message,
            open: true,
          });
        } else {
          setModal({ header: "Error", message: data.message, open: true });
        }
      })
      .catch((err) => console.log(err));
  }

  function handleDateChange(date) {
    setNewDate(date);
  }

  function handleNewMsg() {
    setDates((prevState) => {
      return { ...prevState, selected: "New" };
    });

    setInvoiceMsgState(EditorState.createEmpty());
    setReceiptMsgState(EditorState.createEmpty());
  }

  function handleStatementMsgs(items, id) {
    setUpdateID(id);
    console.log(items);
    const statements = items.find((item) => item.id == id);

    setDates((prevState) => {
      return { ...prevState, selected: statements.fromDate };
    });

    setInvoiceMsgState(stringToDraftjs(statements.invoiceMsg));
    setReceiptMsgState(stringToDraftjs(statements.receiptMsg));
  }

  function handleUpdateStatements() {
    const invoiceMsg = DOMPurify.sanitize(
      draftjsToHtml(convertToRaw(invoiceMsgState.getCurrentContent()))
    );
    const receiptMsg = DOMPurify.sanitize(
      draftjsToHtml(convertToRaw(receiptMsgState.getCurrentContent()))
    );

    const data = {
      id: updateID,
      invoiceMsg: invoiceMsg,
      receiptMsg: receiptMsg,
    };

    Axios.post(
      "/pods/onlinePayments/settings/updateCustomStatementMessages",
      data
    )
      .then((res) => {
        const data = res.data;
        if (data.error == "null") {
          setDates((prevState) => {
            return { ...prevState, items: data.statements };
          });

          setModal({
            header: "Custom Messages",
            message: data.message,
            open: true,
          });
        }
      })
      .catch((err) => console.log(err));
  }

  return (
    <div style={MoreSettingsStyles.body}>
      <Row>
        <Col
          style={
            tab == "customMessages"
              ? MoreSettingsStyles.tabSelectedText
              : MoreSettingsStyles.tabText
          }
          onClick={handleStaementCustomMessages}
        >
          Statements Custom Messages
        </Col>
        <Col
          style={
            tab == "websitePayments"
              ? MoreSettingsStyles.tabSelectedText
              : MoreSettingsStyles.tabText
          }
          onClick={handleTabClick.bind(this, "websitePayments")}
        >
          Website Payments
        </Col>
      </Row>
      <Row>
        <Col style={MoreSettingsStyles.tabBody}>
          {tab == "customMessages" && (
            <div>
              <Row>
                <Col sm={6}>
                  <Row>
                    <Col sm={3} style={MoreSettingsStyles.dateLabel}>
                      From Date:
                    </Col>
                    <Col sm={9}>
                      <Dropdown>
                        <Dropdown.Toggle>{dates.selected}</Dropdown.Toggle>
                        <Dropdown.Menu>
                          {dates.items.map((item, index) => {
                            return (
                              <Dropdown.Item
                                key={index}
                                onClick={handleStatementMsgs.bind(
                                  this,
                                  dates.items,
                                  item.id
                                )}
                              >
                                {item.fromDate}
                              </Dropdown.Item>
                            );
                          })}
                          <Dropdown.Item onClick={handleNewMsg}>
                            New
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                  </Row>
                </Col>
                <Col sm={6}>
                  <Row>
                    <Col sm={3} style={MoreSettingsStyles.newDateLabel}>
                      {dates.selected == "New" && <strong>From Date:</strong>}
                    </Col>
                    <Col sm={5} style={MoreSettingsStyles.dateLabel}>
                      {dates.selected == "New" && (
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={newDate}
                          onChange={(date: Date) => handleDateChange(date)}
                        />
                      )}
                    </Col>
                    <Col sm={4} style={MoreSettingsStyles.saveBtn}>
                      {dates.selected !== "New" ? (
                        <Button onClick={handleUpdateStatements}>Update</Button>
                      ) : (
                        <Button onClick={handleCustomMessagesSave}>Save</Button>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br />
              <Row>
                <Col>
                  <strong>Invoice:</strong> <br /> <br />
                </Col>
                <Col></Col>
              </Row>
              <Editor
                editorState={invoiceMsgState}
                toolbar={{
                  options: [
                    "inline",
                    "blockType",
                    "fontSize",
                    "fontFamily",
                    "list",
                    "textAlign",
                    "colorPicker",
                    "link",
                    "embedded",
                    "emoji",
                    "remove",
                    "history",
                  ],
                }}
                onEditorStateChange={handleInvoiceMsgChange}
                wrapperStyle={MoreSettingsStyles.editorWrapper}
                editorStyle={MoreSettingsStyles.editorStyle}
              />
              <br />
              <strong>Receipt:</strong> <br /> <br />
              <Editor
                editorState={receiptMsgState}
                toolbar={{
                  options: [
                    "inline",
                    "blockType",
                    "fontSize",
                    "fontFamily",
                    "list",
                    "textAlign",
                    "colorPicker",
                    "link",
                    "embedded",
                    "emoji",
                    "remove",
                    "history",
                  ],
                }}
                onEditorStateChange={handleReceiptMsgChange}
                wrapperStyle={MoreSettingsStyles.editorWrapper}
                editorStyle={MoreSettingsStyles.editorStyle}
              />
            </div>
          )}
        </Col>
      </Row>
      <Modal show={modal.open} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{modal.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modal.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default MoreSettings;
